import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  rolesData: [],
  addModal: false,
  editModal: false,
  totalPageNo: 1,
  selectedCounsilor: null,
  addUserLoading: false,
  userDeleteModalOpen: false,
  expChangeLoading: false,
  profileView: false,
  deleteUserLoading: false,
  editQualification: false,
  currentPageNo: 1,
  userImageFile: null,
  wards: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCurrentPageNo: (state, action) => {
      state.currentPageNo = action.payload;
    },
    setProfileView: (state, action) => {
      state.profileView = action.payload;
    },
    setWards: (state, action) => {
      state.wards = action.payload;
    },
    setUserImageFile: (state, action) => {
      state.userImageFile = action.payload;
    },

    setRolesData: (state, action) => {
      state.rolesData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTotalPageNo: (state, action) => {
      state.totalPageNo = action.payload;
    },
    toggleAddModal: (state) => {
      state.addModal = !state.addModal;
    },
    toggleEditModal: (state) => {
      state.editModal = !state.editModal;
    },
    setEditQualification: (state, action) => {
      state.editQualification = action.payload;
    },
    setSelectedCounsilor: (state, action) => {
      state.selectedCounsilor = action.payload;
    },
    clearSelectedUser: (state) => {
      state.selectedCounsilor = null;
    },
    setUserDeleteModalOpen: (state, action) => {
      state.userDeleteModalOpen = action.payload;
    },
    setAddUserLoading: (state, action) => {
      state.addUserLoading = action.payload;
    },
    setDeleteUserLoading: (state, action) => {
      state.deleteUserLoading = action.payload;
    },
    setExpChangeLoading: (state, action) => {
      state.expChangeLoading = action.payload;
    },
  },
});

export const {
  setLoading,
  setTotalPageNo,
  toggleAddModal,
  toggleEditModal,
  setUserDeleteModalOpen,
  setDeleteUserLoading,
  setCurrentPageNo,
  setEditQualification,
  setRolesData,
  setSelectedCounsilor,
  clearSelectedUser,
  setWards,
  setUserImageFile,
  setAddUserLoading,
  setExpChangeLoading,
  setProfileView,
} = userSlice.actions;

export default userSlice.reducer;
